/**
 * @flow weak
 */

import { createSelector } from 'reselect';

// Raw Selectors
export const getSession = (state) => state.session;
export const getCSRFToken = (state) => state.session.csrfToken;
export const getLoading = (state) => state.session.loading;

export const getUser = (state) => {
  if (state.session && state.session.user) {
    return state.session.user;
  }
  return null;
};

export const getAmplitudeInstance = (state) => {
  return state.session.amplitudeInstance || window.amplitude.getInstance();
};

export const getUserSlug = createSelector(
  [getUser],
  (user) => {
    if (user) {
      return user.slug.split('-').pop(); // slug is something like firstname-lastname-ASDFGH =/
    }
    return null;
  }
);

export const getRole = (state) => {
  if (state.session && state.session.user && state.session.user.role) {
    return state.session.user.role;
  }
  return null;
};

export const getWishlistUsers = (state) => {
  if (state.session) {
    return state.session.wishlist || null;
  }
  return null;
};

export const getUserId = (state) => {
  if (state.session && state.session.user) {
    return state.session.user.id;
  }
  return null;
};

export const isInterested = createSelector(
    [getUser, getWishlistUsers],
    (user, wishlistUsers) => {
      if (user && wishlistUsers) {
        return wishlistUsers.user_id === user.id;
      }
      return false;
    }
);

export const getUserCurrencies = createSelector(
  [getUser],
  (user) => (user && user.currencies.length > 0) ? user.currencies : []
);

export const getUserIsHost = createSelector(
  [getUser],
  (user) => user ? user.is_host : false
);

export const getUsersLocale = createSelector(
  [getSession],
  (session) =>  {
    if (session && session.user) {
      return session.user.locale;
    }
    return null;
  }
);

export const getUserEmail = createSelector(
  [getUser],
  (user) => {
    if (user && user.email) {
      return user.email;
    }

    return null;
  }
);

export const getUserUnreadMessagesCount = createSelector(
  [getUser],
  (user) => user ? user.unread_conversations_count : 0
);

export const getUserMemberships = createSelector(
  [getUser],
  (user) => user ? user.memberships : []
);



// WEBPACK FOOTER //
// ./src/modules/session/getters.js